import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { type AyotResponse } from '@backrs_ui/grow-ui/src/redux/coachingAnalytics';

const { coachingAnalytics } = appStrings.modules;

export const useAgentContext = (data: AyotResponse) => {
  useRegisterAgentContext({
    kind: 'section',
    title: coachingAnalytics.onTrack.title,
    description: coachingAnalytics.onTrack.subtitle,
  });

  useRegisterAgentContext({
    kind: 'visual',
    label: coachingAnalytics.onTrack.aspiration.title,
    display:
      'Two cards side by side: a donut of the ahead/aligned/behind split, and a heat matrix of student counts.',
    detail: [
      coachingAnalytics.onTrack.aspiration.matrixInfo,
      coachingAnalytics.onTrack.aspiration.caveat,
      data.aspiration_vs_reality.excluded.no_blueprint > 0 &&
        coachingAnalytics.onTrack.excluded(data.aspiration_vs_reality.excluded.no_blueprint),
    ]
      .filter(Boolean)
      .join('\n\n'),
    data: {
      assessed: data.assessed,
      tracks: data.tracks.map((track) => track.name),
      total: data.aspiration_vs_reality.total,
      statuses: data.aspiration_vs_reality.statuses,
      matrix: data.aspiration_vs_reality.matrix,
      excluded: data.aspiration_vs_reality.excluded,
    },
  });

  useRegisterAgentContext({
    kind: 'visual',
    label: coachingAnalytics.onTrack.academicProfile.title,
    display:
      'Side-by-side histograms of the Academic Profile — grades, testing where available, and rigor — split between high school and post-secondary, with each band also split by the track those students can reach.',
    detail: [
      coachingAnalytics.onTrack.academicProfile.binsTrimmed,
      coachingAnalytics.onTrack.academicProfile.enrollmentAtAssessment,
      data.academic_profile.unclassified > 0 &&
        coachingAnalytics.onTrack.academicProfile.unclassified(data.academic_profile.unclassified),
    ]
      .filter(Boolean)
      .join('\n\n'),
    data: data.academic_profile,
  });

  useRegisterAgentContext({
    kind: 'visual',
    label: coachingAnalytics.onTrack.onTrackStatus.title,
    display:
      'Donut of the on-track/developing/not-yet non-academic verdict, with one stacked bar per category.',
    detail: [
      coachingAnalytics.onTrack.statusByUnlock.nonAcademicCategories,
      data.non_academic_profile.excluded.no_blueprint > 0 &&
        coachingAnalytics.onTrack.excluded(data.non_academic_profile.excluded.no_blueprint),
    ]
      .filter(Boolean)
      .join('\n\n'),
    data: data.non_academic_profile,
  });
};
